import { Route, Routes } from 'react-router-dom'
import { useState, createContext } from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import Discover from './user/Discover'
import Latest from './user/Latest'
import PlayerBar from '../components/player/PlayerBar'
import ChassisPage from './user/Chassis'
import { Alert, Container } from 'react-bootstrap'

export const PlayerContext = createContext()

const Home = () => {
  const [nowPlaying, setNowPlaying] = useState(null)
  const [playlist, setPlaylist] = useState([])
  const [playlistIndex, setPlaylistIndex] = useState(0)
  const [length, setLength] = useState(0)
  const [seekTime, setSeekTime] = useState(0)
  const [playTime, setPlayTime] = useState(0)
  const [volume, setVolume] = useState(1)
  const [repeat, setRepeat] = useState(false)
  const [shuffle, setShuffle] = useState(false)
  const [isPlaying, setIsPlaying] = useState(false)

  const playRecordings = (recordings, index = 0) => {
    setIsPlaying(false)
    setSeekTime(0)
    setPlaylist(recordings)
    setPlaylistIndex(index)
    setNowPlaying(recordings[index])
  }
  const stopPlaying = () => {
    setIsPlaying(false)
    setPlaylist([])
    setNowPlaying(null)
    setPlaylistIndex(0)
  }

  const previousRecording = () => {
    const newIndex = playlistIndex - 1
    if (seekTime > 5 || newIndex < 0) setSeekTime(0)
    else {
      setPlaylistIndex(newIndex)
      setNowPlaying(playlist[newIndex])
    }
  }
  const nextRecording = () => {
    const newIndex = playlistIndex + 1
    if (newIndex >= playlist.length) {
      if (repeat) {
        setPlaylistIndex(0)
        setNowPlaying(playlist[0])
      } else stopPlaying()
    } else {
      setPlaylistIndex(newIndex)
      setNowPlaying(playlist[newIndex])
    }
  }

  const seekRecording = (event) => {
    setSeekTime(event.target.value)
  }

  const updatePlayTime = (event) => {
    setPlayTime(event.target.currentTime)
  }

  const onRecordingLoaded = (event) => {
    setLength(event.target.duration)
    setIsPlaying(true)
  }

  return (
    <PlayerContext.Provider
      value={{
        nowPlaying,
        setNowPlaying,
        playlist,
        setPlaylist,
        length,
        setLength,
        seekTime,
        setSeekTime,
        playTime,
        setPlayTime,
        volume,
        setVolume,
        repeat,
        setRepeat,
        shuffle,
        setShuffle,
        isPlaying,
        setIsPlaying,
        stopPlaying,
        playRecordings,
        previousRecording,
        nextRecording,
        seekRecording,
        updatePlayTime,
        onRecordingLoaded,
      }}
    >
      <Navbar />
      <Container>
        <Alert variant={'info'}>Welcome to an early alpha build of CDLBT Audio. This website is under development. Mobile devices are currently not supported.</Alert>
      </Container>
      <Routes>
        <Route index element={<Discover />} />
        <Route path='/latest' element={<Latest />} />
        <Route path='/chassis/:make/:model' element={<ChassisPage />} />
      </Routes>
      <Footer />
      <PlayerBar />
    </PlayerContext.Provider>
  )
}
export default Home
